<template>
    <div class="box-news-bigImg" @click="window.open(newsData.newsContentURL)">
        <div class="title">
            <div class="content">{{newsData.newsContentTitle}}</div>
        </div>
        <div class="img-box">
            <img :src="newsData.newsContentImage" >
        </div>
        <div class="info-box">
            <span v-if="isAd" class="ad-info">广告</span>
            <span class="source-box">{{newsData.newsContentSource}}</span>
            <span class="createTime-box">{{newsData.newsContentUpdateTime}}</span>
        </div>
        <!--<el-button-group v-if="showControl">
            <el-button type="primary" size="mini">上移</el-button>
            <el-button type="primary" size="mini">下移</el-button>
            <el-button type="primary" icon="edit" size="mini"></el-button>
            <el-button type="primary" icon="delete" size="mini"></el-button>
        </el-button-group>-->
    </div>
</template>
<script>
    export default{
        props: ["newsData", "isAd", "showControl"],
        data(){
            return {
                window: window
            };
        }
    }
</script>
<style lang="less">
    .box-news-bigImg{
        .title{
            overflow: hidden;
            .content{
                line-height: 1.4;
                margin-top: 0;
                padding-right: 8px;
            }
        }
        .img-box{
            width: 100%;
            img{
                width: 100%;
            }
        }
        .info-box{
            font-size: 13px;
            color: #8c97a2;
            margin-top: 5px;
            line-height: 1.5;

            .ad-info{
                font-size: 10px;
                padding: 1px 2px;
                border: 1px solid #8c97a2;
            }

            .createTime-box{
                margin-left: 10px;
            }
        }
    }
</style>




// WEBPACK FOOTER //
// BigImg.vue?090e1218